import React, { useEffect, useState } from "react";
import { Button, Col, Divider, Modal, Row } from "antd";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import { nameCredentialsSchema } from "../../../../validattion";

const CreateProductModal = (props) => {
  // Props
  const {
    visible,
    formMode,
    closeModal,
    one_raw_material,
    UpdateRawMaterial,
    CreateRawMaterial,
  } = props;

  // Hooks states
  const [loading, setLoading] = useState(false);

  const checkMode = formMode === "CREATE_MODE";

  // Form
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(nameCredentialsSchema),
  });

  // Close modal and empty fields
  const closeService = () => {
    reset({ name: "" });
    closeModal();
  };

  // Async function
  const createRawMaterialInventory = async (data) => {
    setLoading(true);
    if (formMode === "CREATE_MODE") {
      const res = await CreateRawMaterial(data);
      if (res.success) {
        setLoading(false);
        toast.success("Raw Material Created Successfully", {
          pauseOnHover: false,
        });
        requestAnimationFrame(() => {
          closeService();
          setLoading(false);
        });
      } else if (!res.success && res.message === undefined) {
        setLoading(false);
        toast.error("Network Error", {
          pauseOnHover: true,
        });
      } else {
        setLoading(false);
        toast.error(res.message, {
          pauseOnHover: true,
        });
      }
      setLoading(false);
    } else if (formMode === "UPDATE_MODE") {
      const updateObj = {
        ...data,
        id: one_raw_material?.id,
      };
      const res = await UpdateRawMaterial(updateObj);
      if (res.success) {
        setLoading(false);
        toast.success("Raw Material Updated Successfully", {
          pauseOnHover: false,
        });
        closeService();
        requestAnimationFrame(() => {
          reset();
          setLoading(false);
        });
      } else if (!res.success && res.message === undefined) {
        setLoading(false);
        toast.error("Network Error", {
          pauseOnHover: true,
        });
      } else {
        setLoading(false);
        toast.error(res.message, {
          pauseOnHover: true,
        });
      }
    }
  };

  // Use effect to update fields
  useEffect(() => {
    if (one_raw_material) {
      setValue("name", one_raw_material?.name);
    }
  }, [one_raw_material]);
  return (
    <>
      <Modal
        visible={visible}
        title={
          <p style={{ fontWeight: "bold" }}>
            {checkMode ? "Create Raw Material" : `Update Raw Material`}
          </p>
        }
        footer={null}
        onCancel={closeService}
        maskClosable={false}
        width={"400px"}
      >
        <form
          onSubmit={handleSubmit(createRawMaterialInventory)}
          autoComplete="off"
        >
          <div className="content">
            <div className="form-group">
              <Row gutter={24}>
                <Col xs={24} xl={24} lg={24}>
                  <label>Name</label>
                  <input
                    name="name"
                    className="ant-input ant-input-lg"
                    placeholder="Type in Name"
                    {...register("name")}
                  />

                  {errors.name && (
                    <span className="error">
                      Raw material name cannot be empty
                    </span>
                  )}
                </Col>
              </Row>
            </div>
          </div>
          <Divider />
          <Row style={{ margin: "2rem 0" }}>
            <Col xs={24} style={{ textAlign: "right" }}>
              <Button
                loading={loading}
                type="primary"
                onClick={handleSubmit(createRawMaterialInventory)}
                style={{ marginRight: "10px" }}
              >
                {formMode === "CREATE_MODE" ? "Save" : "Update"} Material
              </Button>
            </Col>
          </Row>
        </form>
      </Modal>
    </>
  );
};

export default CreateProductModal;
